module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-translation"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column shrink"
  }, [_c('dropdown', {
    attrs: {
      "icon": 'fa fa-ellipsis-v fa-2x action',
      "position": 'top'
    }
  }, [_c('TranslationButtons', {
    attrs: {
      "item": _vm.item
    }
  })], 1)], 1), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("TR" + _vm._s(_vm.item.id))]), _c('div', {
    staticClass: "field"
  }, [_vm._v(_vm._s(_vm.item.id))])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("group")]), _c('div', {
    staticClass: "field"
  }, [_vm._v(_vm._s(_vm.item.group))])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("key")]), _c('div', {
    staticClass: "field"
  }, [_vm._v(_vm._s(_vm.item.key))])]), _c('div', {
    staticClass: "column cutMessage"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("value")]), _c('div', {
    staticClass: "field"
  }, [_vm._v(" " + _vm._s(_vm.item.value))])]), _c('div', {
    staticClass: "column shrink align-self-middle"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'translation',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right fa-3x action"
  })])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-729e810a!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/Translation.vue
// module id = 2589
// module chunks = 1